import GlobalGuideComponent from './component';
import Connector from './connector';

export const GlobalGuide = () => <Connector component={GlobalGuideComponent} />;
